import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';

import get from 'lodash/get';

import createAction from './';
import * as services from '../services/organizationDetails';

export const FETCH_ORGANIZATION_BY_ID = createAsyncAction(createAction('FETCH_ORGANIZATION_BY_ID'));

export const getOrganizationById = organizationId => (dispatch, getState) => {
  dispatch({ type: FETCH_ORGANIZATION_BY_ID.pending });

  const apiCallParams = {
    query: services.GET_ORGANIZATION_BY_ID,
    fetchPolicy: 'no-cache',
    variables: { orgId: organizationId },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { organizationDetails: { orgId, link } } }) => {
      const state = getState();
      const selectedOrganizationToken = get(state, 'auth.organizations.selectedOrganizationToken');

      if (selectedOrganizationToken === orgId) {
        dispatch({
          type: FETCH_ORGANIZATION_BY_ID.success,
          payload: { organizationStoreLink: link },
        });
      }
    })
    .catch((err) => {
      dispatch(errorAction(FETCH_ORGANIZATION_BY_ID.failure, err));
      throw err;
    });
};
